import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 40px;
  font-weight: 500;
  height: 54px;
`;
Container.displayName = 'Container';

export const PointsContainer = styled.div`
  align-items: center;
  background: #f1f1f1;
  color: #0C1C6B;
  display: flex;
  height: 54px;
  justify-content: center;
  min-width: 128px;
`;
PointsContainer.displayName = 'PointsContainer';

export const PointsItem = styled.span`
  min-width: 26px;
  text-align: center;
`;
PointsItem.displayName = 'PointsItem';

export const Space = styled.span`
  padding: 0 8px;
`;
Space.displayName = 'Space';

export const TeamName = styled.div`
  align-items: center;
  background: #172e8c;
  color: #ffffff;
  display: flex;
  height: 54px;
  justify-content: center;
  min-width: 192px;
  padding: 0 16px;
`;
TeamName.displayName = 'TeamName';

export const TeamNameAway = styled(TeamName)`
  background: #2754b7;
`;
TeamNameAway.displayName = 'TeamNameAway';

export const Timer = styled.div`
  align-items: center;
  background: #0C1C6B;
  color: #ffffff;
  display: flex;
  height: 54px;
  justify-content: center;
  min-width: 150px;
  margin-left: 6px;
  padding: 0 8px;
`;
Timer.displayName = 'Timer';
